import React from 'react';

interface HeaderOutletProps {
  outlet: string;
  infoFormOnClick: () => void;
}

const HeaderOutlet = (props: HeaderOutletProps) => {
  return (
    <div className="bg-white sticky top-16 pt-1 laptop:px-36 tablet:px-10 mobile:px-4 shadow-md">
      <div className="flex justify-between">
        <div className="flex flex-col">
          <div className="text-gray-gray700 laptop:text-extraLarge2 tablet:text-extraLarge mobile:text-medium font-interMedium capitalize">
            {props.outlet}
          </div>
          <div className="flex cursor-pointer">
            <div
              onClick={props.infoFormOnClick}
              className="font-interLight font-small text-primary-green">
              Buka Info Form
            </div>
            <img src="/images/chevronRightGreen.svg" alt="Chevron right icon" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderOutlet;
